import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import CssBaseline from '@material-ui/core/CssBaseline';
import MasterPageContainer from './components/MasterPage/MasterPageContainer';

//import { config } from './App.testconfig';
import { config } from './config';
import { store } from './core';
import { getUserConfirmation } from './helpers';

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <>
      <CssBaseline />
      <Provider store={store}>
          <BrowserRouter getUserConfirmation={getUserConfirmation} basename={config.settings.environment.baseUrl}>
              <Route component={MasterPageContainer} />
          </BrowserRouter>
      </Provider>
  </>
    );
  }
}
